import { motion } from 'framer-motion'

export default function SectionHeading({ eyebrow, title, subtitle }) {
  return (
    <div className="text-center max-w-2xl mx-auto">
      {eyebrow ? (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          className="inline-flex items-center gap-2 text-sm font-semibold text-brand-primary"
        >
          <span className="w-2 h-2 rounded-full bg-accent" />
          {eyebrow}
        </motion.div>
      ) : null}
      <motion.h2
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.45, ease: 'easeOut' }}
        className="mt-3 text-2xl sm:text-3xl md:text-4xl font-extrabold text-slate-900"
      >
        {title}
      </motion.h2>
      {subtitle ? (
        <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">{subtitle}</p>
      ) : null}
    </div>
  )
}

